// extracted by mini-css-extract-plugin
export var smallSpinner = "_qw-0";